import {useEffect, useState} from "react";
import LeftSectionBlock from "../../components/LeftSectionBlock";
import RightSectionBlock from "../../components/RightSectionBlock";
import RefreshIcon from "../../assets/images/refresh-icon.png";
import EvidenceIcon from "../../assets/images/evidence.png";
import DemandIcon from "../../assets/images/demand.png";
import GamificationIcon from "../../assets/images/gamification.png";
import NextGenIcon from "../../assets/images/nextgen.png";
import AIEnabledIcon from "../../assets/images/ai-enabled.png";
import HoverBlock from "../../components/HoverBlock";
import Lottie from "lottie-react";
import ClickAnimation from "../../assets/json/ClickAnimation.json";

const MainContent = () => {
  // Separate state variables for each card
  const [isCard1Flipped, setIsCard1Flipped] = useState(false);
  const [isCard2Flipped, setIsCard2Flipped] = useState(false);
  const [isCard3Flipped, setIsCard3Flipped] = useState(false);
  const [isCard4Flipped, setIsCard4Flipped] = useState(false);
  const [isCard5Flipped, setIsCard5Flipped] = useState(false);
  const [showAnimationCursor, setShowAnimationCursor] = useState(true);

  useEffect(() => {
    if (isCard1Flipped) {
      return setShowAnimationCursor(false);
    }
  }, [isCard1Flipped]);

  return (
    <div className="training-container-blk">
      <div className="gray-main-container-blk training-holiday-container">
        <p className="footnote-mobile">
          <HoverBlock description="Click to reveal cards" />
        </p>

        <div className="flex-container">
          <div
            className={`flip-card ${isCard1Flipped ? "flipped" : ""}`}
            onClick={() => setIsCard1Flipped((prev) => !prev)}>
            <div className="flip-card-inner">
              <div className="flip-card-front">
                {showAnimationCursor && (
                  <Lottie
                    className="hover-animation-flipcard"
                    animationData={ClickAnimation}
                  />
                )}

                <img
                  className="refresh-icon-blk"
                  src={RefreshIcon}
                  alt="refresh"
                />
                <img
                  src={EvidenceIcon}
                  className="icon-card-blk"
                  alt="Evidence Based Instructional Design"
                />
                <h3>
                  Evidence-Based <br />
                  Instructional Design
                </h3>
              </div>
              <div className="flip-card-back">
                <img
                  className="refresh-icon-blk"
                  src={RefreshIcon}
                  alt="refresh"
                />
                <p>
                  Our learning methodology is grounded in cognitive science and
                  adult learning principles, fostering critical thinking and
                  deep understanding through practical application and
                  experiential learning.
                </p>
              </div>
            </div>
          </div>

          <div
            className={`flip-card ${isCard2Flipped ? "flipped" : ""}`}
            onClick={() => setIsCard2Flipped((prev) => !prev)}>
            <div className="flip-card-inner">
              <div className="flip-card-front">
                <img
                  className="refresh-icon-blk"
                  src={RefreshIcon}
                  alt="refresh"
                />
                <img
                  className="icon-card-blk"
                  src={DemandIcon}
                  alt="On-Demand Learning"
                />
                <h3>
                  On-Demand <br />
                  Learning
                </h3>
              </div>
              <div className="flip-card-back">
                <img
                  className="refresh-icon-blk"
                  src={RefreshIcon}
                  alt="refresh"
                />

                <p>
                  Our employees have access to a comprehensive library of
                  curated content available 24/7, allowing learners to develop
                  skills at their own pace and align learning with their
                  personal and professional goals.
                </p>
              </div>
            </div>
          </div>

          <div
            className={`flip-card ${isCard3Flipped ? "flipped" : ""}`}
            onClick={() => setIsCard3Flipped((prev) => !prev)}>
            <div className="flip-card-inner">
              <div className="flip-card-front">
                <img
                  className="refresh-icon-blk"
                  src={RefreshIcon}
                  alt="refresh"
                />
                <img
                  src={GamificationIcon}
                  className="icon-card-blk"
                  alt="Gamification and Engagement"
                />
                <h3>
                  Gamification and
                  <br /> Enagement
                </h3>
              </div>
              <div className="flip-card-back">
                <img
                  className="refresh-icon-blk"
                  src={RefreshIcon}
                  alt="refresh"
                />
                <p>
                  We transform the learning journey into an engaging experience
                  through achievement systems, rewards, and friendly
                  competition, boosting motivation and knowledge retention while
                  making learning enjoyable.
                </p>
              </div>
            </div>
          </div>

          <div
            className={`flip-card ${isCard4Flipped ? "flipped" : ""}`}
            onClick={() => setIsCard4Flipped((prev) => !prev)}>
            <div className="flip-card-inner">
              <div className="flip-card-front">
                <img
                  className="refresh-icon-blk"
                  src={RefreshIcon}
                  alt="refresh"
                />
                <img
                  src={NextGenIcon}
                  className="icon-card-blk"
                  alt="NextGen Skills Development"
                />
                <h3>
                  Next-Gen Skills <br />
                  Development
                </h3>
              </div>
              <div className="flip-card-back">
                <img
                  className="refresh-icon-blk"
                  src={RefreshIcon}
                  alt="refresh"
                />
                <p>
                  Focus on emerging technologies and future workplace skills,
                  with particular emphasis on AI, automation, and analytics,
                  preparing our team to lead in the digital transformation era.
                </p>
              </div>
            </div>
          </div>

          <div
            className={`flip-card ${isCard5Flipped ? "flipped" : ""}`}
            onClick={() => setIsCard5Flipped((prev) => !prev)}>
            <div className="flip-card-inner">
              <div className="flip-card-front">
                <img
                  className="refresh-icon-blk"
                  src={RefreshIcon}
                  alt="refresh"
                />
                <img
                  src={AIEnabledIcon}
                  className="icon-card-blk"
                  alt="AI Enabled Feedback"
                />
                <h3>
                  AI-enabled <br />
                  feedback
                </h3>
              </div>
              <div className="flip-card-back">
                <img
                  className="refresh-icon-blk"
                  src={RefreshIcon}
                  alt="refresh"
                />
                <p>
                  Our eLearning modules leverage the power of AI to deliver
                  real-time, personalised feedback, offering tailored responses
                  that enhance learner engagement and understanding.
                </p>
              </div>
            </div>
          </div>
        </div>
        <p className="foot-note-blk footnote-desktop">
          <HoverBlock description="Click to reveal cards" />
        </p>
      </div>
      <div className="training-blurb-blk">
        <p>
          Our learning ecosystem combines advanced technology with gamification
        </p>
        <h2>Go1 Integration</h2>
        <ul>
          <li>
            <p>
              Access to thousands of courses with personalised learning paths
            </p>
          </li>
          <li>
            <p>
              Real-time progress tracking and certifications in relevant skills
            </p>
          </li>
        </ul>

        <h2>Game Changer Platform</h2>
        <ul>
          <li>
            <p>
              Custom-built system awarding experience points for learning
              activities
            </p>
          </li>
          <li>
            <p>
              Experience points are exchangeable for rewards, creating an
              engaging learning environment
            </p>
          </li>
        </ul>
        <p style={{marginTop: "20px"}}>
          This approach keeps our experts at the forefront of industry knowledge
          while providing an interactive and rewarding learning experience.
        </p>
      </div>
    </div>
  );
};

const TrainingPage = () => {
  return (
    <div className="main-container-blk">
      <div className="main-section-blk">
        <LeftSectionBlock />
        <RightSectionBlock
          title="TRAINING"
          previousBtn="/new-expert-orientation"
          nextBtn="/information-security"
          mainContent={<MainContent />}
        />
      </div>
    </div>
  );
};

export default TrainingPage;
